<template>
	<div>
		<modal ref="modalMotivoAssinatura">
			<button type="button" class="close" @click="$refs.modalMotivoAssinatura.modalHide()">
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title">
				{{ _traducao('global', 'motivoReassinatura').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row" v-if="motivo != null">
				<div class="col-xs-12">
					<h3>
						{{ motivo.justificativa_solicitacao }}
					</h3>

					<br />
					<p>
						<strong>{{ _traducao('global', 'porArtigo').toUpperCase() }}:</strong> {{ motivo.nome_usuario_solicitacao }}
					</p>
				</div>
			</div>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-12">
					<button @click="$refs.modalMotivoAssinatura.modalHide()" class="btn btn-default pull-right">
						{{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
	data() {
		return {
			motivo: null
		}
	},

	methods: {
		exibeModal(motivo) {
			this.motivo = motivo
			this.$refs.modalMotivoAssinatura.modalShow(60)
		}
	}
}
</script>